var exports = {
  "Og": "ChannelMessages.module__messagesWrapper___a1pWSE",
  "gs": "ChannelMessages.module__scrollerContainer___a1pWSE",
  "aE": "ChannelMessages.module__bottomFade___a1pWSE",
  "yY": "ChannelMessages.module__bottomFadeStatusAtBottom___a1pWSE",
  "K9": "ChannelMessages.module__bottomFadeStatusScrolled___a1pWSE",
  "gT": "ChannelMessages.module__scrollerContent___a1pWSE",
  "lB": "ChannelMessages.module__scrollerSpacer___a1pWSE",
  "xo": "ChannelMessages.module__scrollerSpacerAfterFiller___a1pWSE",
  "pi": "ChannelMessages.module__fillerBuffer___a1pWSE",
  "CU": "ChannelMessages.module__groupSpacer___a1pWSE",
  "$P": "ChannelMessages.module__groupSpacerHalf___a1pWSE",
  "bv": "ChannelMessages.module__scrollerInner___a1pWSE",
  "eb": "ChannelMessages.module__newMessagesBar___a1pWSE",
  "mC": "ChannelMessages.module__newMessagesBarBanner___a1pWSE",
  "xp": "ChannelMessages.module__newMessagesBarBannerText___a1pWSE",
  "su": "ChannelMessages.module__newMessagesBarBannerAction___a1pWSE",
  "G6": "ChannelMessages.module__messageBottomPill___a1pWSE",
  "Sg": "ChannelMessages.module__jumpToPresentBar___a1pWSE",
  "RQ": "ChannelMessages.module__newMessagesBarText___a1pWSE",
  "As": "ChannelMessages.module__loadErrorBar___a1pWSE",
  "Ku": "ChannelMessages.module__newMessagesBarAction___a1pWSE",
  "WB": "ChannelMessages.module__unreadSlot___a1pWSE",
};

module.exports = exports;
